module.exports = __webpack_public_path__ + "89c1dddb7cda52c4e523a620b1d3f77f.MP3";